import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import GridTable from "../../../../common/components/core/GridTable";
import {useReceiptsGridContext} from '../ReceiptsGridContext';
import styles from './ReceiptsGrid.module.scss';

const ReceiptsGrid = () => {
  const {infiniteScroll, table} = useReceiptsGridContext();

  return (
    <div id={infiniteScroll.containerID} className={styles.scrollContainer}>
      <InfiniteScroll {...infiniteScroll.props} height={648}>
        <GridTable table={table} />
      </InfiniteScroll>
    </div>
  )
};

export default ReceiptsGrid;
